/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthClientUIConfiguration
 */
export interface OAuthClientUIConfiguration {
    [key: string]: any | any;
    /**
     * Configuration for dynamic flow
     * @type {{ [key: string]: any; }}
     * @memberof OAuthClientUIConfiguration
     */
    dynamicFlowConfig?: { [key: string]: any; };
    /**
     * Whether dynamic flow is enabled
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    dynamicFlowEnabled?: boolean;
    /**
     * The types of handles that can be used to authenticate
     * @type {Array<string>}
     * @memberof OAuthClientUIConfiguration
     */
    handleTypes?: Array<string>;
    /**
     * The URL of the logo to display in the login form
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    logoUrl?: string;
    /**
     * The background color of the page
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    pageBackgroundColor?: string;
    /**
     * Whether to show the SlashID badge
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    showBadge?: boolean;
    /**
     * Whether to store the last factor used for authentication
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    storeLastFactor?: boolean;
    /**
     * If set, the support link will be displayed in the error state
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    supportURL?: string;
    /**
     * If set, the alternative auth link will be displayed in the self-registration-not-allowed error state
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    alternativeAuthURL?: string;
    /**
     * The URL of the favicon to display in the browser tab
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    faviconUrl?: string;
    /**
     * The title of the page
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    pageTitle?: string;
    /**
     * The SlashID theme CSS variables
     * @type {{ [key: string]: string; }}
     * @memberof OAuthClientUIConfiguration
     */
    themeVars?: { [key: string]: string; };
    /**
     * Text keys and overriden values
     * @type {{ [key: string]: string; }}
     * @memberof OAuthClientUIConfiguration
     */
    textOverrides?: { [key: string]: string; };
}

/**
 * Check if a given object implements the OAuthClientUIConfiguration interface.
 */
export function instanceOfOAuthClientUIConfiguration(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OAuthClientUIConfigurationFromJSON(json: any): OAuthClientUIConfiguration {
    return OAuthClientUIConfigurationFromJSONTyped(json, false);
}

export function OAuthClientUIConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthClientUIConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'dynamicFlowConfig': !exists(json, 'dynamicFlowConfig') ? undefined : json['dynamicFlowConfig'],
        'dynamicFlowEnabled': !exists(json, 'dynamicFlowEnabled') ? undefined : json['dynamicFlowEnabled'],
        'handleTypes': !exists(json, 'handleTypes') ? undefined : json['handleTypes'],
        'logoUrl': !exists(json, 'logoUrl') ? undefined : json['logoUrl'],
        'pageBackgroundColor': !exists(json, 'pageBackgroundColor') ? undefined : json['pageBackgroundColor'],
        'showBadge': !exists(json, 'showBadge') ? undefined : json['showBadge'],
        'storeLastFactor': !exists(json, 'storeLastFactor') ? undefined : json['storeLastFactor'],
        'supportURL': !exists(json, 'supportURL') ? undefined : json['supportURL'],
        'alternativeAuthURL': !exists(json, 'alternativeAuthURL') ? undefined : json['alternativeAuthURL'],
        'faviconUrl': !exists(json, 'faviconUrl') ? undefined : json['faviconUrl'],
        'pageTitle': !exists(json, 'pageTitle') ? undefined : json['pageTitle'],
        'themeVars': !exists(json, 'themeVars') ? undefined : json['themeVars'],
        'textOverrides': !exists(json, 'textOverrides') ? undefined : json['textOverrides'],
    };
}

export function OAuthClientUIConfigurationToJSON(value?: OAuthClientUIConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'dynamicFlowConfig': value.dynamicFlowConfig,
        'dynamicFlowEnabled': value.dynamicFlowEnabled,
        'handleTypes': value.handleTypes,
        'logoUrl': value.logoUrl,
        'pageBackgroundColor': value.pageBackgroundColor,
        'showBadge': value.showBadge,
        'storeLastFactor': value.storeLastFactor,
        'supportURL': value.supportURL,
        'alternativeAuthURL': value.alternativeAuthURL,
        'faviconUrl': value.faviconUrl,
        'pageTitle': value.pageTitle,
        'themeVars': value.themeVars,
        'textOverrides': value.textOverrides,
    };
}

